export default __webpack_public_path__ + "static/media/i_bus-jeonse_rd.d019caf7.svg";